// removed by extract-text-webpack-plugin
module.exports = {"clickable-element":"_36Ab9","clickable-element-block":"c-EQc","clickable-element-inline":"_1HOY9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickableElement/ClickableElement.scss
// module id = ./src/components/ClickableElement/ClickableElement.scss
// module chunks = 5